var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNaira(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 162618"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 696",
    opacity: 0.18,
    d: "M0 20C0 9.23045 8.73045 0.5 19.5 0.5C30.2696 0.5 39 9.23045 39 20C39 30.7696 30.2696 39.5 19.5 39.5C8.73045 39.5 0 30.7696 0 20Z",
    fill: "#42A4D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 849",
    d: "M11 18.8864V16.4381H12.9336V10.0254H17.371L20.4591 16.4381H24.0897V10.0254H27.8595V16.4381H29.96V18.8864H27.8595V20.347H29.96V22.7952H27.8595V29.973H23.7142L20.167 22.7952H16.7033V29.973H12.9336V22.7952H11V20.347H12.9336V18.8864H11ZM22.3509 20.347H24.0897V18.8864H21.6415L22.3509 20.347ZM16.7033 20.347H18.9707L18.2474 18.8864H16.7033V20.347ZM24.1454 24.1445H24.1871C24.15 23.8292 24.1222 23.3794 24.1037 22.7952H23.5472C23.7513 23.2311 23.9506 23.6808 24.1454 24.1445ZM16.6616 15.4226H16.6059C16.6245 15.7194 16.643 16.0579 16.6616 16.4381H17.065C16.9537 16.1599 16.8192 15.8214 16.6616 15.4226Z",
    fill: "#42A4D9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaira);
export default __webpack_public_path__ + "static/media/naira.d1fc073f5690673f11be5d51ece1b83d.svg";
export { ForwardRef as ReactComponent };